import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useInfiniteQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Chip,
  Grid,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  createStyles,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';

import DenunciasIlus from '../../../../../assets/img/denuncias.png';
import { ReactComponent as RightIcon } from '../../../../../assets/img/icon/Right.svg';
import SubHeader from '../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import { appConfig } from '../../../../../config/app';
import { CustomEvents } from '../../../../../constants/analytics.constant';
import { IncidentsLabels } from '../../../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useIncidentsContext } from '../../../../../context/incidents/incidents.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import useLogEventInAnalytics from '../../../../../hooks/useLogAnalyticsEvent';
import {
  SINISTER_INSPECTION_QUERY,
  sinisterInspectionsQueryAll,
} from '../../../../../query/sinisterInspections/sinisterInspections';

const useStyle = makeStyles(() =>
  createStyles({
    incidentsImg: {
      width: '20%',
      maxWidth: '500px',
      minWidth: '150px',
    },
    card: {
      height: '100%',
      '& a': {
        height: '100%',
      },
      '& div': {
        height: '100%',
      },
    },
  })
);

const ListIncidents = () => {
  const classes = useStyle();
  const history = useHistory();
  const { user } = useAuthDataContext();
  const { getIncidentById } = useIncidentsContext();
  const { logEvent } = useLogEventInAnalytics();

  const [page, setPage] = useState(1);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  let lastPageEmpty = 0;
  let lastPage = [];

  const {
    data: incidents,
    isLoading: loading,
    fetchNextPage,
    hasNextPage: next,
  } = useInfiniteQuery(SINISTER_INSPECTION_QUERY, sinisterInspectionsQueryAll, {
    getNextPageParam: (lastPage) => {
      // console.log('lastPage',lastPage.at(-1), incidents.pages.at(-1))
      lastPageEmpty = lastPage.length;
      lastPage = lastPage;
    },
  });

  useEffect(() => {
    dataLayerPush('Cuenta_mis_denuncias', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    logEvent(CustomEvents.COMPLAINTS_VIEW, {
      app: appConfig?.NAME,
    });
  }, [logEvent]);

  const selectedIncidentByID = (id) => {
    getIncidentById(id, incidents);
    history.push('/account/incidentDetails/' + id);
  };

  const handleNextPage = () => {
    fetchNextPage({ pageParam: page + 1 });
    setPage((prev) => prev + 1);
  };

  const HandleMore = () => {
    // Robustecer validación para detectar si hace falta cargar más registros o no.

    // Según lo consultado con BE, el paginado se realiza de a 20 registros por vez, por lo que para poder mostrar
    // un scroll infinito tendría que hacerce de a 20 registros por vez.
    let val =
      lastPageEmpty > 0 && incidents?.pages?.flat().length >= 20 ? true : false;
    return val;
  };

  return (
    <>
      <Box display={loading || !incidents?.pages ? 'block' : 'none'}>
        <Loader action={'Cargando denuncias'}></Loader>
      </Box>

      <SubHeader
        content={
          <Box>
            <Typography variant="h6"> Mis denuncias </Typography>
          </Box>
        }
      ></SubHeader>

      {incidents?.pages && (
        <Grid container justify="center">
          <Grid item xs={11}>
            <Grid container>
              <Grid item xs={12}>
                {matches ? (
                  <div
                    id="scrollableDiv"
                    style={{
                      height: 600,
                      overflow: 'auto',
                    }}
                  >
                    <InfiniteScroll
                      //This is important field to render the next data
                      dataLength={incidents?.pages?.flat().length}
                      next={handleNextPage}
                      hasMore={HandleMore()}
                      loader={
                        <Box style={{ width: '100%' }}>
                          <LinearProgress color="primary" />
                        </Box>
                      }
                      endMessage={
                        <Box m={2}>
                          <Typography
                            style={{ textAlign: 'center' }}
                            color="textSecondary"
                          >
                            Ya hemos mostrado todos los resultados
                          </Typography>
                        </Box>
                      }
                      // height={matches ? 600 : null}
                      scrollableTarget={'scrollableDiv'}
                    >
                      <>
                        {incidents && !incidents?.pages?.flat().length ? (
                          <Box my={4} textAlign="center">
                            {/* <img
                              className={classes.incidentsImg}
                              src={DenunciasIlus}
                              alt={'Denuncias'}
                            ></img> */}
                            <Typography variant="h6">
                              {' '}
                              ¡No tenés denuncias!{' '}
                            </Typography>
                            <Typography variant="body2">
                              {' '}
                              Cuando realices una denuncia vas a poder darle
                              seguimiento desde acá.{' '}
                            </Typography>
                          </Box>
                        ) : (
                          <Grid container justify="center">
                            <Grid item xs={11}>
                              <Grid container>
                                <Grid item xs={12}>
                                  {incidents && !incidents?.pages?.flat() ? (
                                    <Box my={4} textAlign="center">
                                      {/* <img
                                        className={classes.incidentsImg}
                                        src={DenunciasIlus}
                                        alt={'Denuncias'}
                                      ></img> */}
                                      <Typography variant="h6">
                                        {' '}
                                        ¡No tenés denuncias!{' '}
                                      </Typography>
                                      <Typography variant="body2">
                                        {' '}
                                        Cuando realices una denuncia vas a poder
                                        darle seguimiento desde acá.{' '}
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Box my={2}>
                                      <TableContainer component={Paper}>
                                        <Table aria-label="incidents table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell
                                                style={{ fontWeight: 'bold' }}
                                              >
                                                {' '}
                                                Denuncia{' '}
                                              </TableCell>
                                              <TableCell
                                                align="center"
                                                style={{ fontWeight: 'bold' }}
                                              >
                                                {' '}
                                                Tipo póliza/patente{' '}
                                              </TableCell>
                                              <TableCell
                                                align="center"
                                                style={{ fontWeight: 'bold' }}
                                              >
                                                {' '}
                                                Status{' '}
                                              </TableCell>
                                              <TableCell align="center">
                                                {' '}
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {incidents?.pages
                                              ?.flat()
                                              ?.map((incident: any) => (
                                                <Fade in={true}>
                                                  <TableRow
                                                    hover
                                                    key={incident.id}
                                                    onClick={() =>
                                                      selectedIncidentByID(
                                                        incident.id
                                                      )
                                                    }
                                                  >
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      <Box>
                                                        <Typography
                                                          style={{
                                                            display:
                                                              'inline-block',
                                                            marginRight: '10px',
                                                          }}
                                                          component="span"
                                                          variant="h3"
                                                        >
                                                          {IncidentsLabels[
                                                            incident
                                                              .incident_type
                                                          ] ||
                                                            incident.incident_type}
                                                        </Typography>
                                                        <Typography
                                                          style={{
                                                            display:
                                                              'inline-block',
                                                          }}
                                                        >
                                                          Nº {incident.number}
                                                        </Typography>
                                                      </Box>
                                                      <Typography>
                                                        {incident?.date
                                                          ?.split('-')
                                                          .reverse()
                                                          .join('/')}
                                                      </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {incident.item
                                                        .license_plate ||
                                                      incident.product.code ===
                                                        4
                                                        ? incident.item
                                                            .license_plate
                                                        : incident.product
                                                            .description}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      <Box m={1}>
                                                        <Chip
                                                          style={{
                                                            borderRadius: '3px',
                                                          }}
                                                          variant="outlined"
                                                          label={
                                                            incident.status
                                                          }
                                                          size="small"
                                                        />
                                                      </Box>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                      <RightIcon></RightIcon>
                                                    </TableCell>
                                                  </TableRow>
                                                </Fade>
                                              ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Box>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </>
                    </InfiniteScroll>
                  </div>
                ) : (
                  <InfiniteScroll
                    //This is important field to render the next data
                    dataLength={incidents?.pages?.flat().length}
                    next={handleNextPage}
                    hasMore={HandleMore()}
                    loader={
                      <Box style={{ width: '100%' }}>
                        <LinearProgress color="primary" />
                      </Box>
                    }
                    endMessage={
                      <Box m={2}>
                        <Typography
                          style={{ textAlign: 'center' }}
                          color="textSecondary"
                        >
                          Ya hemos mostrado todos los resultados
                        </Typography>
                      </Box>
                    }
                    height={matches ? 600 : null}
                    // scrollableTarget={"scrollableDiv"}
                  >
                    <>
                      {incidents && !incidents?.pages?.flat().length ? (
                        <Box my={4} textAlign="center">
                          {/* <img
                            className={classes.incidentsImg}
                            src={DenunciasIlus}
                            alt={'Denuncias'}
                          ></img> */}
                          <Typography variant="h6">
                            {' '}
                            ¡No tenés denuncias!{' '}
                          </Typography>
                          <Typography variant="body2">
                            {' '}
                            Cuando realices una denuncia vas a poder darle
                            seguimiento desde acá.{' '}
                          </Typography>
                        </Box>
                      ) : (
                        <Grid container justify="center">
                          <Grid item xs={11}>
                            <Grid container>
                              <Grid item xs={12}>
                                {incidents && !incidents?.pages?.flat() ? (
                                  <Box my={4} textAlign="center">
                                    {/* <img
                                      className={classes.incidentsImg}
                                      src={DenunciasIlus}
                                      alt={'Denuncias'}
                                    ></img> */}
                                    <Typography variant="h6" color="primary">
                                      {' '}
                                      ¡No tenés denuncias!{' '}
                                    </Typography>
                                    <Typography variant="body2">
                                      {' '}
                                      Cuando realices una denuncia vas a poder
                                      darle seguimiento desde acá.{' '}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box my={2}>
                                    <TableContainer component={Paper}>
                                      <Table aria-label="incidents table">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell
                                              style={{ fontWeight: 'bold' }}
                                            >
                                              {' '}
                                              Denuncia{' '}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{ fontWeight: 'bold' }}
                                            >
                                              {' '}
                                              Tipo póliza/patente{' '}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{ fontWeight: 'bold' }}
                                            >
                                              {' '}
                                              Status{' '}
                                            </TableCell>
                                            <TableCell align="center">
                                              {' '}
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {incidents?.pages
                                            ?.flat()
                                            ?.map((incident: any) => (
                                              <Fade in={true}>
                                                <TableRow
                                                  hover
                                                  key={incident.id}
                                                  onClick={() =>
                                                    selectedIncidentByID(
                                                      incident.id
                                                    )
                                                  }
                                                >
                                                  <TableCell
                                                    component="th"
                                                    scope="row"
                                                  >
                                                    <Box>
                                                      <Typography
                                                        style={{
                                                          display:
                                                            'inline-block',
                                                          marginRight: '10px',
                                                        }}
                                                        component="span"
                                                        variant="h3"
                                                      >
                                                        {IncidentsLabels[
                                                          incident.incident_type
                                                        ] ||
                                                          incident.incident_type}
                                                      </Typography>
                                                      <Typography
                                                        style={{
                                                          display:
                                                            'inline-block',
                                                        }}
                                                      >
                                                        Nº {incident.number}
                                                      </Typography>
                                                    </Box>
                                                    <Typography>
                                                      {incident?.date
                                                        ?.split('-')
                                                        .reverse()
                                                        .join('/')}
                                                    </Typography>
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {incident.item
                                                      .license_plate ||
                                                    incident.product.code === 4
                                                      ? incident.item
                                                          .license_plate
                                                      : incident.product
                                                          .description}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    <Box m={1}>
                                                      <Chip
                                                        style={{
                                                          borderRadius: '3px',
                                                        }}
                                                        variant="outlined"
                                                        label={incident.status}
                                                        size="small"
                                                      />
                                                    </Box>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    <RightIcon></RightIcon>
                                                  </TableCell>
                                                </TableRow>
                                              </Fade>
                                            ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Box>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </>
                  </InfiniteScroll>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ListIncidents;
